import { assignUserToOffice } from "../api/userService";

export const useAssignUserOffice = () => {
    const assign = async (userId, officeId) => {
    try {
        const response = await assignUserToOffice(userId, officeId);
        const newAssignment = response;
        return newAssignment; // still return the created record
    } 
    catch (error) {
        console.error("Error assigning user to office:", error);
        throw error;
    }
  };

  return { assign };
};